import { render } from "./panoramica.vue?vue&type=template&id=66531aa6&bindings={\"navigate\":\"props\"}"
import script from "./panoramica.vue?vue&type=script&lang=js"
export * from "./panoramica.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./panoramica.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script